import {
  Component,
  ContentChild,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  TemplateRef,
} from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { EventCardComponent } from '../event-card/event-card.component';
import { RouterLink } from '@angular/router';
import { EventSkeletonComponent } from '../event-skeleton/event-skeleton.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { EventModel, EventType } from '../../models';
import { FilteringOptionsComponent } from '../filtering-options/filtering-options.component';
import { InfiniteScrollDirective } from '@hypenation/shared/directives';

export type EventsListLoadMode = 'none' | 'button' | 'auto';

@Component({
  selector: 'hypenation-tickets-events-list',
  standalone: true,
  imports: [
    CommonModule,
    NgTemplateOutlet,
    EventCardComponent,
    RouterLink,
    EventSkeletonComponent,
    FilteringOptionsComponent,
    InfiniteScrollDirective,
    NzSpinModule,
  ],
  templateUrl: './events-list.component.html',
  styleUrl: './events-list.component.css',
})
export class EventsListComponent {
  public readonly totalItems: InputSignal<number> = input(0);
  public readonly events: InputSignal<Array<EventModel>> = input<
    Array<EventModel>
  >([]);
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly title: InputSignal<string | undefined> = input<
    string | undefined
  >(undefined);
  public readonly showFiltering: InputSignal<boolean> = input<boolean>(false);
  public readonly eventsTypes: InputSignal<EventType[]> = input<EventType[]>(
    []
  );
  public readonly loadMode: InputSignal<EventsListLoadMode> =
    input<EventsListLoadMode>('none');
  public readonly hasMore: InputSignal<boolean> = input<boolean>(false);
  public readonly loadingMore: InputSignal<boolean> = input<boolean>(false);

  public readonly selectEventCategory: OutputEmitterRef<EventType> =
    output<EventType>();
  public readonly clearFilter: OutputEmitterRef<void> = output<void>();
  public readonly loadMore: OutputEmitterRef<void> = output<void>();

  @ContentChild('cardTemplate', { read: TemplateRef })
  public cardTemplate: TemplateRef<{ $implicit: EventModel }> | undefined;

  public onSelectEventCategory(category: EventType) {
    this.selectEventCategory.emit(category);
  }

  public onClearFilter() {
    this.clearFilter.emit();
  }

  public onLoadMoreClick(): void {
    if (this.hasMore() && !this.loadingMore()) {
      this.loadMore.emit();
    }
  }

  public onSentinelIntersect(): void {
    this.loadMore.emit();
  }
}
